export default __webpack_public_path__ + "static/media/TermsOfUse-EN.d7612c1b.pdf";